import InputSizer from './InputSizer.component';

export default InputSizer;
